module.exports = __webpack_public_path__ + "static/media/inter.0f8b6e6d.svg";